import { BottomSheet, navigationRef } from '@betty/navigation';
import { startListening, isAnyOf, verifyIdentity } from '@betty/toolkit/state';
import { getAccount, setAccount, selectAccount } from '@betty/account/state';
import {
  getWelcomePromos,
  selectWelcomePromosState,
} from '@betty/promos/state';
import {
  selectDepositCountState,
  selectHasUserDeposited,
} from '@betty/wallet/state';
import { getDepositCount } from '@betty/wallet/state';
import { getOnboardingStep } from './onboarding.utils';

startListening({
  actionCreator: getDepositCount.fulfilled,
  effect: (_, { dispatch, getState }) => {
    const hasUserDeposited = selectHasUserDeposited(getState());

    if (!hasUserDeposited) {
      dispatch(getWelcomePromos());
    }
  },
});

startListening({
  matcher: isAnyOf(verifyIdentity, getAccount.fulfilled, setAccount),
  effect: async (_, { getState, condition, cancelActiveListeners }) => {
    cancelActiveListeners();

    const depositCountState = selectDepositCountState(getState());

    if (depositCountState === 'idle' || depositCountState === 'pending') {
      await condition(getDepositCount.fulfilled.match);
    }

    const hasUserDeposited = selectHasUserDeposited(getState());
    const welcomePromosState = selectWelcomePromosState(getState());

    if (
      !hasUserDeposited &&
      (welcomePromosState === 'idle' || welcomePromosState === 'pending')
    ) {
      await condition(getWelcomePromos.fulfilled.match);
    }

    const account = selectAccount(getState());

    if (!account) {
      return;
    }

    const { status, statusReason, verificationMeta } = account;

    if (statusReason === 'KYC Address Mismatch') {
      navigationRef.navigate('AddressVerificationScreen');

      return;
    }

    const onboardingStep = await getOnboardingStep({
      status,
      statusReason,
      hasUserDeposited,
      verificationMeta,
    });

    const currentRouteName = navigationRef?.current?.getCurrentRoute()?.name;

    if (
      onboardingStep &&
      currentRouteName !== 'DepositScreen' &&
      currentRouteName !== 'PaymentStatusScreen'
    ) {
      BottomSheet.open({
        namespace: 'onboarding',
        type: 'Onboarding',
        titleKey: `${onboardingStep}Title`,
        titleNS: 'onboarding',
        replace: true,
        data: {
          step: onboardingStep,
        },
      });
    }
  },
});
